const MessagesConfig = {
	//MESSAGE TYPES USED TO IDENTIFY MESSAGES
	SessionMessageTypes: {
		REQUEST_SESSION_STATUS: 'REQUEST_SESSION_STATUS',
		SESSION_STATUS: 'SESSION_STATUS',
		SESSION_INIT: 'SESSION_INIT',
	},

	//MESSAGE STATUS USED INSIDE THE PAYLOAD OF RECEIVED AND SENT MESSAGES
	MessageStatus: {
		OK: 'OK',
		ERROR: 'ERROR',
	},
};

export default MessagesConfig;